import type { IconProps } from './types';
import './icons.css';

export default function Export({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-export ${className || ''}`}
    >
      <path
        d="M14 11.3334V12.6667C14 13.7334 13.6667 14.6667 12.3999 14.6667H3.59993C2.33333 14.6667
        2 13.7334 2 12.6667V11.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        fill="transparent"
      />
      <path
        d="M8.0001 1.19997V11.6M8.0001 1.19997L3.6001 5.48233M8.0001 1.19997L12.4001 5.48233"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
